import { render, staticRenderFns } from "./DisputeAssigneeModal.vue?vue&type=template&id=aaffae6a"
import script from "./DisputeAssigneeModal.vue?vue&type=script&lang=js"
export * from "./DisputeAssigneeModal.vue?vue&type=script&lang=js"
import style0 from "./DisputeAssigneeModal.vue?vue&type=style&index=0&id=aaffae6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports